import { getParameterByName } from './parse.url';
import { Auth } from '@aws-amplify/auth';
import { signin, signInEvent, config, initialRoute, isMasqUrl } from './authn.config';
const instance = Auth;
const who = (__GMK_COGNITO_WHO_TO_IMPERSONATE__ || getParameterByName('email'));
const canImpersonate = __GMK_COGNITO_CAN_IMPERSONATE__;
const wantsToImpersonate = !!who;
const isMasquradable = /.*@.*/.test(who);
const configuredToBeAble = !!config.oauth.scope.find(s => s == 'aws.cognito.signin.user.admin');
/** perform logic to specify a user who's security is wanted */
isMasqUrl(initialRoute) && wantsToImpersonate && isMasquradable && configuredToBeAble && (async () => {
    var _a;
    try {
        //user
        await signInEvent;
        const user = await instance.currentUserPoolUser();
        const attrs = await new Promise((resolve, reject) => user.getUserAttributes((oops, u) => !!oops ? reject(oops) : resolve(u)));
        const masq = (_a = attrs.find(a => a.Name === 'custom:masq')) === null || _a === void 0 ? void 0 : _a.Value;
        //get out because we already are who we want to be
        if (masq == who) {
            return;
        } //truth
        if (!masq && !who) {
            return;
        } //falsy
        //setup masquerading
        await instance.updateUserAttributes(user, { 'custom:masq': who });
        await signin();
    }
    catch (error) {
        if (__GMK_COGNITO_VUE_DEBUG__) {
            console.warn(`[@growmark/cognito-vue](${__GMK_COGNITO_APP_NAME__}): failed to update impersonation detail`, who, error);
        }
    }
})();
/* remove impersonation */
isMasqUrl(initialRoute) && !wantsToImpersonate && configuredToBeAble && (async () => {
    var _a;
    try {
        //user
        await signInEvent;
        const user = await instance.currentUserPoolUser();
        const attrs = await new Promise((resolve, reject) => user.getUserAttributes((oops, u) => !!oops ? reject(oops) : resolve(u)));
        const masq = (_a = attrs.find(a => a.Name === 'custom:masq')) === null || _a === void 0 ? void 0 : _a.Value;
        //get out because we already are who we want to be
        if (!masq && !who) {
            return;
        } //already what we want
        //setup masquerading
        await instance.deleteUserAttributes(user, ['custom:masq']);
        await signin();
    }
    catch (error) {
        if (__GMK_COGNITO_VUE_DEBUG__) {
            console.warn(`[@growmark/cognito-vue](${__GMK_COGNITO_APP_NAME__}): failed to update impersonation detail`, who, error);
        }
    }
})();
isMasqUrl(initialRoute) && wantsToImpersonate && !isMasquradable && console.debug(`[@growmark/cognito-vue](${__GMK_COGNITO_APP_NAME__}): impersonation not possible because of details`, who);
isMasqUrl(initialRoute) && wantsToImpersonate && !canImpersonate && console.debug(`[@growmark/cognito-vue](${__GMK_COGNITO_APP_NAME__}): impersonation not possible`, who);
isMasqUrl(initialRoute) && canImpersonate && configuredToBeAble && (() => { throw `[@growmark/cognito-vue](${__GMK_COGNITO_APP_NAME__}): impersonating ${who}`; });
//# sourceMappingURL=handle.impersonation.js.map